<template>
  <div class="plan-selector">
    <div class="plan-selector-field form-group"
         :class="{'has-error': validator && validator.$error}">
      <label class="form-label" for="batch-plan">Convênio / plano</label>
      <select id="batch-plan" class="form-select" :value="value" :disabled="disabled"
              @change="onChange($event.target.value)" @blur="validator && validator.$touch()">
        <option value="">[Selecione o convênio]</option>
        <option v-for="item in plans" :value="item.id" :key="item.id">{{ item.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    plans: {
      type: Array,
      default: () => [],
    },
    validator: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
      this.$emit('change', this.plans.find(item => item.id === value) || null);
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
.plan-selector {
  flex: 1 1 18rem;
  .plan-selector-field {
    margin-bottom: 0;
    max-width: 24rem;
  }
}
</style>
